import { useState } from "react";
import Config from "../../../Config";
import MediaBrowser from "../../../helpers/MediaBrowser";



function DayPlan(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);



    const getData = () => {


        props.mainView.setProgress(-2);

        var req = {

        };


        fetch( Config.url + '/rest_v1_parents,day_plan', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }


    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
    }    
    
    

    return (
        <div>
                     <ul className="parents_eat">

                         {
                            tab.map( (item, ix) => {

                                    return <li>
                                               <div className="calColor" >{item.godzina}, {item.tytul}</div>
                                               <div>
                                                     <p> {item.opis} </p> 
                                               </div>
                                    </li>

                            } )
                         }   

                     </ul>
        </div>
    )
}


export default DayPlan;